import { LOCAL_WIDGET_ID, WidgetTokenProvider } from '@elfsight/lib-utils';
import { WidgetI18nProvider } from '@elfsight/widget-i18n';
import { useFontsLoader } from '@elfsight/widget-ui';
import { WidgetRectProvider } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import DICTIONARY from '../language/dictionary.json';
import { ImagesProvider } from './widget/components/images';
import { LightboxProvider } from './widget/components/lightbox';
import { Widget } from './widget/widget';

export function PhotoGallery() {
  const { font, language, widgetId, widgetToken } = useSettings();

  useFontsLoader([font]);

  return (
    <WidgetTokenProvider
      widgetToken={widgetToken}
      widgetId={widgetId || LOCAL_WIDGET_ID}
    >
      <WidgetI18nProvider
        dictionary={DICTIONARY}
        language={language?.language}
        override={language?.messages}
      >
        <LightboxProvider>
          <ImagesProvider>
            <WidgetRectProvider>
              <Widget />
            </WidgetRectProvider>
          </ImagesProvider>
        </LightboxProvider>
      </WidgetI18nProvider>
    </WidgetTokenProvider>
  );
}
